import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import PersonalInfo from './sections/PersonalInfo';
import Certifications from './sections/Certifications';
import Experience from './sections/Experience';
import Projects from './sections/Projects';
import Education from './sections/Education';
import Skills from './sections/Skills';
import Awards from './sections/Awards';
import IndustryExperience from './sections/IndustryExperience';
import { profileApi } from '../../services/api';
import '../../styles/Profile.css';

const sections = [
    { id: 'personal', label: 'المعلومات الشخصية', icon: 'user' },
    { id: 'certifications', label: 'الشهادات', icon: 'award' },
    { id: 'experience', label: 'الخبرة', icon: 'briefcase' },
    { id: 'projects', label: 'المشاريع', icon: 'code' },
    { id: 'education', label: 'التعليم', icon: 'graduation' },
    { id: 'skills', label: 'المهارات', icon: 'tool' },
    { id: 'awards', label: 'الجوائز', icon: 'trophy' },
    { id: 'industryExperience', label: 'خبرة القطاع', icon: 'building' }
];

export default function ProfileManager() {
    const [activeSection, setActiveSection] = useState('personal');
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadProfile();
    }, []);

    const loadProfile = async () => {
        try {
            setLoading(true);
            const data = await profileApi.getFullProfile();
            setProfile(data.data);
            setError(null);
        } catch (err) {
            setError('Failed to load profile data');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const refreshSection = async (sectionName) => {
        // Reload full profile to update counts
        await loadProfile();
    };

    const renderSection = () => {
        if (loading) return <div className="section-loading">جاري تحميل الملف الشخصي...</div>;
        if (error) return <div className="section-error">{error}</div>;

        const sectionProps = { profile, onRefresh: refreshSection };

        switch (activeSection) {
            case 'personal':
                return <PersonalInfo {...sectionProps} />;
            case 'certifications':
                return <Certifications {...sectionProps} />;
            case 'experience':
                return <Experience {...sectionProps} />;
            case 'projects':
                return <Projects {...sectionProps} />;
            case 'education':
                return <Education {...sectionProps} />;
            case 'skills':
                return <Skills {...sectionProps} />;
            case 'awards':
                return <Awards {...sectionProps} />;
            case 'industryExperience':
                return <IndustryExperience {...sectionProps} />;
            default:
                return <PersonalInfo {...sectionProps} />;
        }
    };

    // Calculate item counts for sidebar
    const getCounts = () => {
        if (!profile) return {};
        return {
            certifications: profile.certifications?.length || 0,
            experience: profile.experience?.length || 0,
            projects: profile.projects?.length || 0,
            education: profile.education?.length || 0,
            skills: profile.skills?.length || 0,
            awards: profile.awards?.length || 0,
            industryExperience: profile.industryExperience?.length || 0
        };
    };

    return (
        <div className="profile-manager">
            <Sidebar
                sections={sections}
                activeSection={activeSection}
                onSectionChange={setActiveSection}
                counts={getCounts()}
            />
            <div className="profile-content">
                {renderSection()}
            </div>
        </div>
    );
}
